import { FC, Fragment, useState } from 'react';

import { convertCentsToDollars, getExistingSpecifiedItems } from '@packages/utils';

import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { useBoostSelectionModal } from '@hooks';
import { i18n } from '@i18n';
import { getSelectedBoostById, useTripStore } from '@store';

import { Loader } from '../loader';
import { SpecifiedItemListItem } from '../specifiedItemListItem';

type Props = {
  boostId?: string;
  showButton?: boolean;
};

export const SpecifiedItemsList: FC<Props> = ({ boostId, showButton = true }) => {
  const removeBoost = useTripStore(state => state.removeBoost);
  const boost = useTripStore(getSelectedBoostById(boostId));
  const specifiedItemsList = getExistingSpecifiedItems(boost);
  const [isRemoveLoading, setIsRemoveLoading] = useState(false);
  const openBoostModal = useBoostSelectionModal(boostId);

  const onRemoveAll = async () => {
    if (!boostId) {
      return;
    }
    setIsRemoveLoading(true);
    await removeBoost({ boostId });
    setIsRemoveLoading(false);
  };
  const numberOfItems = specifiedItemsList.length;

  if (!specifiedItemsList || !numberOfItems) {
    return <></>;
  }

  return (
    <>
      <div className=" border-cabo-200 mb-4 rounded-lg border p-4">
        <div className="border-cabo-200 flex flex-row items-start justify-between border-b pb-4 sm:items-center">
          <Text variant="subTitle-20/sb">
            {i18n.t('boostDetails.specifiedItems.title', { count: numberOfItems })}
          </Text>
          {isRemoveLoading && <Loader size="sm" />}
          {!isRemoveLoading && (
            <button onClick={onRemoveAll} className="underline whitespace-nowrap">
              <Text variant="subHeading-14/m">
                {i18n.t('boostDetails.boostHeader.primaryButton.removeAll')}
              </Text>
            </button>
          )}
        </div>
        {specifiedItemsList.map((it, index) => {
          return (
            <Fragment key={it.itemId}>
              <SpecifiedItemListItem specifiedItem={it} index={index} />
            </Fragment>
          );
        })}
        <div className="border-cabo-200 flex flex-row items-center justify-between pt-2">
          <Text variant="subTitle-20/sb">{i18n.t('boostDetails.specifiedItems.subtotal')}</Text>
          <Text variant="subTitle-20/sb">{convertCentsToDollars(boost?.price)}</Text>
        </div>
      </div>
      {showButton && (
        <Button
          onClick={() => openBoostModal()}
          variant="feature"
          className="my-5"
          title={i18n.t('boostDetails.specifiedItems.primaryButton.add')}
        />
      )}
    </>
  );
};
